export default "__VITE_ASSET__e9a2d045__"